const News = () => {
  const newsCategoriesEl = document.querySelector('#newsCategories');
  const newsListCategoryNameEls = document.querySelectorAll('.news__list-category-name');

  //newsCategoriesを生成
  newsListCategoryNameEls.forEach((newsListCategoryNameEl:HTMLElement) => {
    const newsCategoryHtmlStr = `<div class="news__category"><span class="news__category-btn">${newsListCategoryNameEl.textContent}</span></div>`;
    newsCategoriesEl.insertAdjacentHTML('beforeend', newsCategoryHtmlStr);
  });

  //news__category

  //newsCategoriesの.news__category-btnをクリックしたら、そのnews__category-btnをcurrentにする その他の-currentを削除。同じ.news__list-category-nameの.news__listを表示
  newsCategoriesEl.addEventListener('click', (e:MouseEvent) => {
    const target = e.target as HTMLElement;
    if (target.classList.contains('news__category-btn')) {
      //news__category-btnをcurrentにする
      const newsCategoryBtn = target.closest('.news__category-btn');
      newsCategoryBtn.classList.add('-current');
      newsCategoriesEl.querySelectorAll('.news__category-btn').forEach((newsCategoryBtnEl:HTMLElement) => {
        if (newsCategoryBtnEl !== newsCategoryBtn) {
          newsCategoryBtnEl.classList.remove('-current');
        }
      });
      //newsCategoryBtnのindexを取得
      const targetIndex = Array.from(newsCategoriesEl.querySelectorAll('.news__category-btn')).indexOf(newsCategoryBtn);
      //targetのindexと同じindexの.news__listを表示
      const newsList = document.querySelectorAll('.news__list')[targetIndex];
      newsList.classList.add('-current');
      setTimeout(() => {
        newsList.classList.add('-show');
      }, 10);
      document.querySelectorAll('.news__list').forEach((newsListEl:HTMLElement) => {
        if (newsListEl !== newsList) {
          newsListEl.classList.remove('-current');
          newsListEl.classList.remove('-show');
        }
      });
    }
  });

  //一つ目の.news__category-btnをクリックしておく
  (newsCategoriesEl.querySelectorAll('.news__category-btn')[0] as HTMLElement).click();
};

export default News;